/**
 * If accommodation is selected (to show hotel details), otherwise go back
 * to accommodation list.
 */
export default defineNuxtRouteMiddleware((to) => {
    const localeRoute = useLocaleRoute();
    const { product } = useProduct<ProductAccommodation>(to);
    const flowType = computed(() => product.value.isUpsell ? 'upsell' : 'booking');

    if (!product.value.accommodation) {
        return navigateTo(localeRoute({
            name: 'offerFlow-hotel-steps-step-4-accommodation-list',
            params: { productRouteId: getProductRouteId(product.value.id) ?? '', flowType: flowType.value },
            query: to.query,
        }));
    }
});
